export const environmentBase = {
  app: 'front',
  indexDBVersion: 2.0,
  itemsPageSize: 20,
  categoriesPageSize: 5,
  setupFutureUsage: true,
  accessTokenCookieName: 'gb_front_token',
}
